<template>
  <div class="container comment">
    <div class="row">
      <user-avatar-component :avatarURL="comment.userAvatarUrl" :userLevel="comment.userLevel" id="userAvatar"/>

      <div class="col commentContentArea">
        <div class="row">
          <div class="commentUserInfo">
            <!-- Username, Creationdate -->
          <span class="username" @click="clickProfile">{{comment.username}}</span> <span class="creationDate">{{creationString}}</span>
          </div>
        </div>
        <div class="row" v-if="comment.text != null">
          <!-- Comment Text -->
          {{comment.text}}
        </div>
        <div class="row" v-if="comment.mediaUrl != null">
          <!-- Comment GIF -->
          <img :src="gifLink" class="gifWrapper">
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ItemComment } from '@/dto/ItemComment'
import { emitter } from '@/main'
import { EmittEvent } from '@/dto/enums/EmittEvent'
import UserAvatarComponent from '@/views/components/UserAvatarComponent.vue'
import { logProfileClick } from '@/services/EventLogger'
import { randomFileServer } from '@/services/Api'

export default defineComponent({
  components: {
    UserAvatarComponent
  },

  props: {
    comment: {
      type: ItemComment,
      required: true
    }
  },

  setup() {
    return { }
  },

  computed: {
    creationString(): String {
      return this.comment.created.toLocaleString()
    },

    gifLink(): String | null {
      if (!this.comment.mediaUrl) {
        return null
      }

      if (!this.comment.mediaUrl.startsWith('http')) {
        // https://file1.live.mega.lol/pool/comment/gif/1777611.gif
        return randomFileServer() + this.comment.mediaUrl
      }

      return this.comment.mediaUrl
    }
  },

  methods: {
    clickProfile() {
      logProfileClick()
      emitter.emit(EmittEvent.downloadAppAlert)
    }
  }
})
</script>

<style lang="sass" scoped>
.comment
  padding: 12px

.commentContentArea
  margin-left: 8px

#userAvatar
  width: 50px
  padding: 0

.commentUserInfo
  padding: 0

.username
  cursor: pointer
  font-weight: 700

.creationDate
  font-weight: 500
  font-size: 0.8rem
  color: $color_on_background_medium

.gifWrapper
  height: 150px
  width: auto
  border-radius: 12px
  padding: 0
  margin-top: 6px
</style>
